<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-px-lg">
            <span v-if="elements.length == 1">
              <jt-dynamic-form
                ref="dynamicForm"
                :inputs="formateInputs"
                :relacionamentos="elements[0].relacionamentos"
                :model="elements[0].dadosForm"
                :interface="elements[0].nmInterface"
                form-class="form dynamic"
                class="balanceForm"
                @on-select-change="onSelectChange"
              />
            </span>
          </q-card-section>
          <q-card-section class="q-px-lg">
            <div
              v-if="elements[0].dadosForm.communicationType === 20140001"
              class="row q-gutter-x-md"
            >
              <div class="col-3">
                <jt-input
                  type="text"
                  name="text"
                  v-model="elements[0].dadosForm.ipNumber"
                  required
                  :float-label="$gettext('IP_NUMBER')"
                  inverted
                  @input="
                    () => {
                      $forceUpdate();
                    }
                  "
                >
                </jt-input>
              </div>
              <div
                v-for="(portBalance, index) in elements[0].dadosForm
                  .portBalances"
                v-bind:key="index"
                class="col-3"
              >
                <jt-input
                  type="number"
                  name="number"
                  v-model="portBalance.port"
                  required
                  :float-label="$gettext('PORT')"
                  inverted
                  @input="setEditable(portBalance)"
                >
                </jt-input>
              </div>
              <q-btn
                class="bg-blue-grey text-white full-height self-center q-py-xs"
                icon="add"
                @click="createNewPort"
              ></q-btn>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div
      v-if="forms[0] && forms[0].buttons.length > 0"
      class="row full-width q-col-gutter-lg justify-center q-pt-md"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-3"
      >
        <q-btn class="full-width" color="info" @click="actionButton(button)">
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm, JtInput } from 'jtech-webcomps'
import { repository } from 'jtech'
const { page } = JtCrud
@Component({
  mixins: [page],
  name: 'landfillBalancePage',
  components: { JtDynamicForm, page, JtInput },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
class LandfillBalancePage extends Vue {
  dados = {};

  async beforeMount () {
    await this._inti()
  }

  async _inti () {
    if (!this.elements[0].dadosForm.portBalances) {
      this.elements[0].dadosForm.portBalances = []
    }
    if (
      this.elements[0].dadosForm.communicationType === 20140001 &&
      this.elements[0].dadosForm.portBalances.length === 0
    ) {
      this.createNewPort()
    }
    this.dados = {
      ...this.elements[0].dadosForm,
      portBalances: [...this.elements[0].dadosForm.portBalances]
    }
  }

  async onSelectChange (data) {
    const { selectedValue, input } = data
    if (selectedValue && input.name === 'balanceSerial') {
      const param = { id: selectedValue }
      const { registros } = await repository.resolveDatatableModel(
        'balanceSerial.pesquisar',
        param
      )
      this.$set(this.elements[0].dadosForm, 'year', registros[0].year)
      this.$set(this.elements[0].dadosForm, 'capacity', registros[0].capacity)
    } else if (!selectedValue && input.name === 'balanceSerial') {
      this.elements[0].dadosForm.year = null
      this.elements[0].dadosForm.capacity = null
    }
  }

  @Watch('element.dadosForm.communicationType')
  setportBalances (newValue, oldValue) {
    if (newValue === 20140001) {
      this.elements[0].dadosForm.ipNumber = this.dados.ipNumber
      this.elements[0].dadosForm.portBalances = [...this.dados.portBalances]

      this.dados.serialNumber =
        this.elements[0].dadosForm.serialNumber || this.dados.serialNumber
      this.dados.baud = this.elements[0].dadosForm.baud || this.dados.baud
      this.dados.dataSize =
        this.elements[0].dadosForm.dataSize || this.dados.dataSize
      this.dados.parityType =
        this.elements[0].dadosForm.parityType || this.dados.parityType
      if (this.elements[0].dadosForm.portBalances.length == 0) {
        this.createNewPort()
      }
    } else {
      this.dados.ipNumber =
        this.elements[0].dadosForm.ipNumber || this.dados.ipNumber
      this.dados.portBalances = [...this.elements[0].dadosForm.portBalances]

      this.elements[0].dadosForm.serialNumber = this.dados.serialNumber
      this.elements[0].dadosForm.baud = this.dados.baud
      this.elements[0].dadosForm.dataSize = this.dados.dataSize
      this.elements[0].dadosForm.parityType = this.dados.parityType

      this.removePortEmpty()
    }
  }

  createNewPort () {
    this.elements[0].dadosForm.portBalances.push({
      port: '',
      balanceCommunicationType: this.elements[0].dadosForm
        .balanceCommunicationType
    })
    this.$forceUpdate()
  }

  validatePort () {
    this.removePortEmpty()
    if (
      this.elements[0].dadosForm.communicationType === 20140001 &&
      (this.elements[0].dadosForm.portBalances.length == 0 ||
        this.elements[0].dadosForm.ipNumber == null)
    ) {
      this.createNewPort()
      return false
    }
    return true
  }

  removePortEmpty () {
    let i = 0
    let length = this.elements[0].dadosForm.portBalances.length

    while (i < length) {
      if (
        this.elements[0].dadosForm.portBalances[i].port === null ||
        this.elements[0].dadosForm.portBalances[i].port === ''
      ) {
        this.elements[0].dadosForm.portBalances.splice(i, 1)
        length--
      } else {
        i++
      }
    }
  }

  get element () {
    return this.elements[0]
  }

  setEditable (portBalance) {
    portBalance.id ? (portBalance.flAlterado = 'S') : ''
    this.$forceUpdate()
  }

  actionButton (button) {
    if (
      (!this.isButtonValidForm(button) || this.isValidForm()) &&
      this.validatePort()
    ) {
      this.removePortEmpty()
      this.$emit('action-button', button, this.getParams(), this)
    } else {
      this.$emit('show-message', 'warning', 'REQUIRED_FIELDS_NOT_FILLED', this)
    }
  }

  get formateInputs () {
    return this.elements[0].inputs.filter(i => i.type != 'COMPOSICAO')
  }
}
export default LandfillBalancePage
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
.balanceForm{
   #scroll-area {
    height: calc(53vh - 0px)!important;
  }
}
</style>
